import React from 'react'
import { ArrayInput, Button, SimpleFormIterator } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { EventBriefQuestion } from 'services/api/entities/events/types/internal/services'
import { isActive } from 'services/utils'
import EventBriefQuestionInput from './EventBriefQuestionInput'

type Props = {
  serviceSource: string
}

const EventServiceBriefSection: React.FC<Props> = ({ serviceSource }) => {
  const { setValue, watch } = useFormContext()

  const briefQuestionValues: EventBriefQuestion[] = watch(
    `${serviceSource}.briefQuestions`
  )

  const areSomeQuestionsInactive = briefQuestionValues.some((q) => !isActive(q))

  const toggleAllLabel = areSomeQuestionsInactive
    ? 'Activate all'
    : 'De-activate all'

  const toggleAll = () => {
    briefQuestionValues.forEach((_s, i) =>
      setValue(
        `${serviceSource}.briefQuestions.${i}.status`,
        areSomeQuestionsInactive ? 'active' : 'inactive',
        { shouldDirty: true }
      )
    )
  }

  return (
    <React.Fragment>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
        <Button
          label={toggleAllLabel}
          variant="contained"
          size="large"
          onClick={toggleAll}
        />
      </div>
      <ArrayInput
        source={`${serviceSource}.briefQuestions`}
        label="Brief Questions"
      >
        <SimpleFormIterator disableAdd disableRemove disableReordering>
          <EventBriefQuestionInput />
        </SimpleFormIterator>
      </ArrayInput>
    </React.Fragment>
  )
}

export default EventServiceBriefSection
